import { Component, ElementRef } from '@angular/core'
import {
  MbCheckoutBillingInformationBaseComponent
} from '../mb-checkout-billing-information-base.component'
import {
  EventService,
  GlobalMessageService,
  TranslationService,
  UserPaymentService,
  WindowRef
} from '@spartacus/core'
import { ActivatedRoute } from '@angular/router'
import { MbCheckoutCommonService } from '../../../services/mb-checkout-common.service'
import { MbCheckoutBillingAddressesConnector, MbPaymentModeConnector } from '../../../connectors'
import { MbCheckoutStepService } from '../../../services/mb-checkout-step.service'
import { MbCheckoutBillingFacade } from '../../../facades/mb-checkout-billing.facade'
import { MbCheckoutRegions } from '../../../../models'
import { CheckoutDeliveryAddressFacade, CheckoutPaymentFacade } from '@spartacus/checkout/base/root'
import { CheckoutStepService } from '@spartacus/checkout/base/components'
import { ActiveCartFacade } from '@spartacus/cart/base/root'

@Component({
  selector: 'mb-checkout-billing-information-au',
  templateUrl: './mb-checkout-billing-information-au.component.html',
  styleUrls: ['../mb-checkout-billing-information-base.component.scss']
})
export class MbCheckoutBillingInformationAuComponent extends MbCheckoutBillingInformationBaseComponent {

  checkoutRegion = MbCheckoutRegions.AU

  constructor (protected userPaymentService: UserPaymentService,
               protected checkoutDeliveryAddressFacade: CheckoutDeliveryAddressFacade,
               protected checkoutPaymentService: CheckoutPaymentFacade,
               protected globalMessageService: GlobalMessageService,
               protected activatedRoute: ActivatedRoute,
               protected translation: TranslationService,
               protected activeCartService: ActiveCartFacade,
               protected checkoutStepService: CheckoutStepService,
               protected mbCheckoutCommonService: MbCheckoutCommonService,
               protected mbCheckoutBillingAddressesConnector: MbCheckoutBillingAddressesConnector,
               protected mbPaymentModeConnector: MbPaymentModeConnector,
               protected mbCheckoutStepService: MbCheckoutStepService,
               protected mbCheckoutBillingFacade: MbCheckoutBillingFacade,
               protected el: ElementRef,
               protected winRef: WindowRef,
               protected eventService: EventService) {
    super(userPaymentService, checkoutDeliveryAddressFacade,checkoutPaymentService, globalMessageService,
      activatedRoute, translation, activeCartService, checkoutStepService, mbCheckoutCommonService,
      mbCheckoutBillingAddressesConnector, mbPaymentModeConnector, mbCheckoutStepService, mbCheckoutBillingFacade,
      el, winRef, eventService)
  }
}
